import { Component, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'app/dialogs/dialog.service';
import { AlertStatus } from 'app/enums/alert-status.enum';
import { PermissionType } from 'app/enums/permission.enum';
import { Alert, AlertHistory } from 'app/models/alerts/alert-list.model';
import { ComplaintDetail, ComplaintLevel } from 'app/models/complaints/complaint.interface';
import { Item } from 'app/models/item.inferface';
import { WorkflowStepHistoryDto } from 'app/models/workflow/workflow-instance.interface';
import { AppFormComponent } from 'app/modules/app-form/form-test/app-form.component';
import { SimpleFileUploaderComponent } from 'app/modules/simple-file-uploader/simple-file-uploader.component';
import { AlertService } from 'app/services/alert.service';
import { AuthService } from 'app/services/auth.service';
import { ComplaintService } from 'app/services/complaint.service';
import { DataSourceService } from 'app/services/data-source.service';
import { ToastService } from 'app/services/toast.service';
import { Subject } from 'rxjs';
import { WorkflowCurrentStepComponent } from '../workflow/workflow-current-step/workflow-current-step.component';
import { ComplaintDetailComponent } from '../complaint-detail/complaint-detail.component';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-detail',
  templateUrl: './alert-detail.component.html',
  styleUrls: ['./alert-detail.component.scss']
})
export class AlertDetailComponent implements OnInit {

  orientation = 'horizontal';
  form: UntypedFormGroup;
  complaintTypeForm: UntypedFormGroup;
  criticalityTypes: Item[];
  alertDetail: Alert;
  complaintTypes: ComplaintLevel[] = [];
  newHistories: AlertHistory[] = [];
  onContinueSubject: Subject<void> = new Subject<void>();

  @ViewChild('fileUploader', {static: true})
  private fileUploader: SimpleFileUploaderComponent;

  @ViewChild(WorkflowCurrentStepComponent) currentStepComponent: WorkflowCurrentStepComponent;

  @ViewChildren(AppFormComponent)
  private formComponents: QueryList<AppFormComponent>;
  loading: boolean;
  AlertStatus = AlertStatus;
  workflowHistory: WorkflowStepHistoryDto[];

  buttonDetailComplaint:boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private dataSouceService: DataSourceService,
    private alertService: AlertService,
    private dialogs: MatDialog,
    private toast: ToastService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AlertDetailComponent>,
    private complaintService: ComplaintService,
    private dialogService: DialogService,
    private authService: AuthService,
    ) {
    if (screen.width < 590) {
      this.orientation = 'vertical';
    }

    this.buttonDetailComplaint = this.authService.userHasPermission(PermissionType.ViewComplaintClassificationFromAlert);

    // this.alertDetail = this.route.snapshot.data.alertDetail;
    // this.complaintTypes = this.route.snapshot.data.complaintTypes;
    // this.workflowHistory = this.route.snapshot.data.workflowHistory;

    if(this.data.alertDetail){
      this.alertDetail = this.data.alertDetail;
    }

    this.complaintService.getComplaintTypes().subscribe(
      res => {
        this.complaintTypes = res;
      },
      err => {
        console.log(err);
      }
    );

    this.complaintTypeForm = this.formBuilder.group({
      formTypeId: [null],
      internalId: ['']
    });

    if(this.alertDetail){
      this.complaintTypeForm.patchValue({
        formTypeId: this.alertDetail.complaint?.formSubTypeId,
        internalId: this.alertDetail.internalId
      });
    }else{
      this.alertService.getAlertById(data.id).subscribe(
        res => {
          this.alertDetail = res;
          this.onContinueSubject.next(void 0);
          this.complaintTypeForm.patchValue({
            formTypeId: this.alertDetail.complaint?.formSubTypeId,
            internalId: this.alertDetail.internalId
          });
        },
        err => console.log(err)
      );
    }
    
  }

  ngOnInit(): void {
    
    this.form = this.formBuilder.group({
      alertCode: [''],
      alertEntity: ['', Validators.required],
      sourceCode: ['', Validators.required],
      sourceId: [''],
      description: ['', Validators.required],
      sourceDescription: ['', Validators.required],
      criticalityId: [0, Validators.required],
      newsDetail: []
    });

    // this.complaintTypeForm = this.formBuilder.group({
    //   formTypeId: [null],
    //   internalId: ['']
    // });
    
    // if (this.alertDetail) {
      // this.complaintTypeForm.patchValue({
      //   formTypeId: this.alertDetail.complaint?.formSubTypeId,
      //   internalId: this.alertDetail.internalId
      // });
    // }

    this.form.patchValue(this.alertDetail);
    this.form.disable();
  }


  downloadNewsFiles(file) {
    const downloadLink = document.createElement('a');
    downloadLink.href = file.url;
    downloadLink.download = file.name;
    downloadLink.click();
  }

  onCloseDialog(){
    this.dialogRef.close();
  }

  viewComplaintDetail(){
    if(this.alertDetail?.complaintId) {
      this.complaintService.getComplaintById(Number(this.alertDetail.complaintId))
        .subscribe(
          (value: ComplaintDetail) => {
            // this.dialogService.openAppFormDialog(value.complaintCompletedForm);
            this.dialogs.open(ComplaintDetailComponent, {
              width: '100%',
              height: '100%',
              maxWidth: '100%',
              disableClose: true,
              data:{
                complaint: value
              }
            })
            .afterClosed()
            .subscribe()
          },
          err => this.toast.error(err))
    }
  }
}
